import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { LOGO, NAV_ITEMS, WA } from '../../constants';
import { ExternalLink } from '../ui';

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,padding,box-shadow] duration-300 ${scrolled ? 'bg-goshine-dark/95 shadow-lg py-3' : 'bg-goshine-dark/80 py-4'}`}>
      <div className="container mx-auto px-4 flex items-center justify-between">
        <a href="#hero">
          <img src={LOGO} alt="GoShine" className="h-8 sm:h-10 md:h-12" />
        </a>
        
        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-6">
          {NAV_ITEMS.map(item => (
            <a key={item.id} href={`#${item.id}`} className="nav-link text-sm">
              {item.text}
            </a>
          ))}
          <ExternalLink href={WA} className="btn-primary text-sm py-2.5 px-5">
            Agendar
          </ExternalLink>
        </div>

        {/* Mobile Menu Button */}
        <button 
          type="button" 
          className="lg:hidden flex items-center justify-center w-12 h-12 text-white text-2xl rounded-lg bg-white/10 active:bg-white/20 transition-colors" 
          onClick={() => setMenuOpen(!menuOpen)} 
          aria-label={menuOpen ? 'Fechar' : 'Menu'} 
          aria-expanded={menuOpen}
        >
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden fixed inset-x-0 top-[72px] bottom-0 bg-goshine-dark transition-[opacity,transform] duration-300 z-40 ${menuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}`}>
        <div className="container mx-auto px-4 py-6 flex flex-col gap-4 bg-goshine-dark">
          {NAV_ITEMS.map(item => (
            <a 
              key={item.id} 
              href={`#${item.id}`} 
              className="text-lg text-gray-300 hover:text-goshine-orange py-2 border-b border-white/5" 
              onClick={closeMenu}
            >
              {item.text}
            </a>
          ))}
          <ExternalLink 
            href={WA} 
            className="btn-whatsapp justify-center mt-4" 
            onClick={closeMenu}
          >
            <FontAwesomeIcon icon={faWhatsapp} className="text-xl" />
            Agendar pelo WhatsApp
          </ExternalLink>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
